module.exports = __webpack_public_path__ + "img/shenticeping_fwsrz.e5477910.png";